/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

enum TableCellIcon {
    WarningExclamation,
    Exclamation,
    Warning,
}

export default TableCellIcon
